import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('cs-CZ', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function formatShortDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('cs-CZ', {
    day: 'numeric',
    month: 'short'
  });
}

export function getDayName(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('cs-CZ', { weekday: 'long' });
}

export function isToday(dateString) {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  return date.toDateString() === today.toDateString();
}

export function truncateText(text, maxLength = 150) {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
}

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Administrátor',
  editor: 'Editor',
  teacher: 'Učitelka',
  kitchen_manager: 'Vedoucí školní jídelny',
  deputy_director: 'Zástupkyně ředitele'
};

// Mapping role -> kterým admin sekcím má uživatel přístup
// Pokud role tu není uvedena, předpokládá se plný přístup (super_admin, admin, editor, teacher)
export const ROLE_NAV_ACCESS = {
  teacher: [],  // Učitelky nemají přístup do administrace
  kitchen_manager: ['menu'],
  deputy_director: ['news', 'gallery', 'events', 'menu', 'messages']
};

// Sekce, na které smí pouze super_admin / admin (i bez role-restrikce)
export const ADMIN_ONLY_NAV = new Set(['users', 'maintenance', 'backup', 'landing', 'theme', 'analytics']);

export const canAccessNav = (role, navKey) => {
  if (!role) return false;
  if (ADMIN_ONLY_NAV.has(navKey)) {
    return role === 'super_admin' || role === 'admin';
  }
  const allowed = ROLE_NAV_ACCESS[role];
  if (!allowed) return true; // role bez restrikce má plný přístup
  return allowed.includes(navKey);
};

export const CATEGORY_LABELS = {
  uredni_deska: 'Úřední deska',
  pro_rodice: 'Pro rodiče',
  formulare: 'Formuláře'
};
